import * as React from 'react';

interface IBundleContext {
    preset: ICategoryPresets;
}

export const BundleContext = React.createContext<IBundleContext>({ preset: null });
